export class EventSettingsModel {
	constructor() {
		this.showFreePlaces = true;
		this.hasChildTicket = false;
		this.planPriceFilterType = 1; //1 - По цене, 2 - По id ценововой зоны
	}

	isPlanPriceFilterById() {
		return this.planPriceFilterType === 2;
	}

	validateAndAddSettings(settings = {}) {
		if (settings.hasOwnProperty("showFreePlaces"))
			this.showFreePlaces = settings.showFreePlaces;
		if (settings.planPriceFilterType) this.planPriceFilterType = settings.planPriceFilterType;
		if (settings.hasChildTicket) this.hasChildTicket = true;
	}

	getSettings() {
		return {
			showFreePlaces: this.showFreePlaces,
			planPriceFilterType: this.planPriceFilterType,
			hasChildTicket: this.hasChildTicket,
		};
	}
}
